import { useEffect, useState } from "react";
import axios from "axios";
import { CENTRAL_CALL } from "../../../App";
import SaveData from "./SaveData";
const PolicySyncingForm = () => {
    const [IsProductList, setIsProductList] = useState([]);
    const [IsInsurerList, setIsInsurerList] = useState([]);
    const [IsCustomer, setIsCustomer] = useState();
    const [GetVehicleDetails, setGetVehicleDetails] = useState();
    const [GetRelatioship, setGetRelatioship] = useState();
    const [SendData, setSendData] = useState();
    const [formData, setFormData] = useState({
        PolicyType: "",
        Relation: 0,
        CustomerName: IsCustomer,
        Insurer: "",
        PolicyNo: "",
        PolicyExpiryDate: "",
        VehicleNo: "",
        IsCompanyVehicle: false,
        PolicyPdfData: "",
        VariantId: 0,
    });
    const [IsGetManuf, setIsGetManuf] = useState([]);
    const [IsGetModel, setIsGetModel] = useState();
    const [IsGetFuel, setGetFuel] = useState();
    const [IsGetVarient, setIsGetVarient] = useState();
    const [IsGetRTO, setIsGetRTO] = useState();
    const [vehicleData, setVehicleData] = useState({
        Manufacturer: "",
        ManufacturerName: "",
        Model: "",
        ModelName: "",
        Fuel: "",
        FuelName: "",
        Varient: "",
        VarientName: ""
    });

    const [errors, setErrors] = useState({});
    const [showupdatefield, setShowUpdateField] = useState(false)
    const [currentFormType, setCurrentForm] = useState("init")
    const [isEditClicked, setIsEditClicked] = useState(false)
    const formatDateToDDMMYYYY = (dateString) => {
        const date = new Date(dateString); // Use Date object to handle conversion
        const day = String(date.getDate()).padStart(2, '0');  // Ensure two digits
        const month = String(date.getMonth() + 1).padStart(2, '0');  // Month is zero-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;

        return dateString?.split("-").reverse().join("-");
    };
    //console.log(formData, "Sync Data");
    const handleChange = (e) => {
        const { name, value } = e.target;
        //console.log({ name, value })
        setFormData({
            ...formData,
            [name]: name === "Relation" || name === "Insurer" ? parseInt(value) : value,
        });

        if (name === "PolicyType" && value) {
            GetManufacturer(value)
        }

        if (name === "PolicyType") {
            GetInsurerList(value);
        }
    };

    const VhandleChange = (e) => {
        const { name, value } = e.target;
        let nameKey = name + "Name";
        const selectedOption = e.target.selectedOptions[0];
        const NameValue = selectedOption.getAttribute('extrakey')
        console.log({ name, value, NameValue });

        setVehicleData((prevState) => ({
            ...prevState,
            [name]: value,
            [nameKey]: NameValue

        }));

        if (name === "Manufacturer" && value) {
            GetModel(value);
        }
        if (name === "Model" && value) {
            GetFuel(value);
        }
        if (name === "Fuel" && value) {
            GetVarient(value);
        }
        console.log({ vehicleData })
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.PolicyType) newErrors.PolicyType = "Policy type is required.";
        if (!formData.Relation) newErrors.Relation = "Relation is required.";
        //if (!formData.CustomerName) newErrors.CustomerName = "Customer name is required.";
        if (!formData.Insurer) newErrors.Insurer = "Insurer is required.";
        if (!formData.PolicyNo) newErrors.PolicyNo = "Policy number is required.";
        if (!formData.PolicyExpiryDate) newErrors.PolicyExpiryDate = "Policy expiry date is required.";
        if (!formData.VehicleNo) newErrors.VehicleNo = "Vehicle number is required.";
        //if (formData.IsCompanyVehicle === "") newErrors.IsCompanyVehicle = "Specify if it's a company vehicle.";
        /*if (!formData.PolicyPdfData) newErrors.PolicyPdfData = "Upload the policy PDF.";*/
        return newErrors;
    };

    const PolicySync = async () => {
        const validationErrors = validateForm();
        let value = formData?.VehicleNo
        let vahanData = await GetVahan(value);
        const formattedData = {
            ...formData,
            PolicyExpiryDate: formatDateToDDMMYYYY(formData.PolicyExpiryDate),
        };
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        let obj = vahanData ? {
            formattedData, vahanData
        } : { formattedData }
        setSendData(obj);
        vahanData ? setCurrentForm("view") : setCurrentForm("edit")
    }
    const token = localStorage.getItem("smc-csp-token");
    const GetProductList = async () => {
        try {
            const response = await axios.get(
                "https://www.smcinsurance.com/CustomerPanelApi/api/Masters/GetProductList",
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            const productList = response.data;
            setIsProductList(productList);
            console.log("Product List:", productList);

            // Fetch insurer list after successfully fetching product list

        } catch (error) {
            console.error("Error fetching product list:", error);
            alert("Failed to fetch product list. Please try again.");
        }
    };

    const GetInsurerList = async (productCode) => {
        try {
            const response = await axios.get(
                "https://www.smcinsurance.com/CustomerPanelApi/api/Masters/GetInsurerList/?productCode=" + productCode,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            const insurerList = response.data;
            setIsInsurerList(insurerList);
            console.log("Insurer List:", insurerList);
        } catch (error) {
            console.error("Error fetching insurer list:", error);
            alert("Failed to fetch insurer list. Please try again.");
        }
    };


    const GetVahan = async (vehicleNo) => {
        try {
            const response = await axios.post(CENTRAL_CALL, {
                URL: `vahanapi`,
                VehicleNo: vehicleNo,
                IsPost: false,
                Req: vehicleNo
            });
            if (!response.data && response.data.statusCode !== 200) {
                return null
            }
            else if (response.data && response.data.statusCode === 200) {
                setGetVehicleDetails(response.data); // Assuming response.data contains the vehicle details
                setFormData({
                    ...formData,
                    VehicleNo: vehicleNo,
                    VariantId: response.data.response.variantID,
                    // map other vehicle details from response.data if available
                });
                setCurrentForm("view")

                return response.data
            }
        } catch (error) {
            console.error("Error fetching vehicle data:", error);
            return null;
        }
    };

    //console.log(GetVehicleDetails, "V-DeV");


    const GetManufacturer = async (VehicleType) => {

        let VType = VehicleType || formData.PolicyType;
        try {
            let manModel = {
                URL: "GetManufacture_Core",
                Req: VType,
            };
            const response = await axios.post(CENTRAL_CALL, manModel);
            if (response.data) {
                setIsGetManuf(response.data.response)
                // console.log(response.data.response, "response data")
            }
        } catch (error) {
            console.error("Error fetching vehicle data:", error);
        }
    };
    const GetModel = async (Manufacturer) => {
        try {
            let vehModel = {
                URL: "GetModel_Core",
                Req: `id=${Manufacturer}&vehicleType=${formData.PolicyType}`
            };
            const response = await axios.post(CENTRAL_CALL, vehModel);
            if (response.data) {
                setIsGetModel(response.data.response)
                //console.log(response.data.response, "response data")
            }
        } catch (error) {
            console.error("Error fetching vehicle data:", error);
        }
    };
    const GetFuel = async (Model) => {
        try {
            let fuelModel = {
                URL: "GetFuel_Core",
                Req: Model,
            };
            const response = await axios.post(CENTRAL_CALL, fuelModel);
            if (response.data) {
                setGetFuel(response.data.response)
                //console.log(response.data.response, "response data")
            }
        } catch (error) {
            console.error("Error fetching vehicle data:", error);
        }
    };
    const GetVarient = async (Fuel) => {
        let Model = vehicleData.Model;
        try {
            let varientModel = {
                URL: "GetVariant_Core",
                Req: `VehicleID=${Model}&FuelID=${Fuel}`,
            };
            const response = await axios.post(CENTRAL_CALL, varientModel);
            if (response.data) {
                setIsGetVarient(response.data.response)
                //console.log(response.data.response, "response data")
            }
        } catch (error) {
            console.error("Error fetching vehicle data:", error);
        }
    };

    const GetRTO = async () => {
        try {
            const response = await axios.get(CENTRAL_CALL);
            if (response.data) {
                setIsGetRTO(response.data)
                console.log(response.data, "response data")
            }
        } catch (error) {
            console.error("Error fetching vehicle data:", error);
        }
    };
    const relationShipData = [
        { name: 'Self', value: 1, key: 69 },
        { name: 'Father', value: 2, key: 32 },
        { name: 'Mother', value: 3, key: 36 },
        { name: 'Son', value: 4, key: 43 },
        { name: 'Daughter', value: 5, key: 44 },
        { name: 'Spouse', value: 6, key: 263 },
        { name: 'Brother', value: 7, key: 46 },
        { name: 'Sister', value: 8, key: 45 },
        // {name: 'Other', value: 0, key: 9},
    ];
    useEffect(() => {
        if (formData.VehicleNo) {
            GetVahan(formData.VehicleNo); // Fetch initial vehicle data if available
        }
        setGetRelatioship(relationShipData);
        GetProductList();
        setIsCustomer(localStorage.getItem("smc-csp-customer-name"));
    }, []);
    useEffect(() => {
        GetManufacturer()
        GetModel();
        GetFuel();
        GetVarient();
        GetRTO();
    }, []);
    const onEditClick = () => {
        setIsEditClicked(true)
        setCurrentForm("init")

        GetManufacturer()
    }
    console.log({ currentFormType, vehicleData })

    const onUpdateClick = () => {
        console.log({ vehicleData, formData })

        setSendData({ ...vehicleData, ...formData })
        setCurrentForm("view")

    }

    return (

        <div className="row">
            <div className="col-md-12">
                {currentFormType !== "view" ?
                <div className="SyncPolicyForm">
                    {(currentFormType === "edit" || isEditClicked) &&
                        <>
                            <ul>
                                <li>
                                    <div className="form-floating">
                                        <select
                                            className="form-select"
                                            id="floatingSelectManufacturer"
                                            name="Manufacturer"
                                            value={vehicleData.Manufacturer || ""}
                                            onChange={VhandleChange}
                                            aria-label="Select vehicle manufacturer"
                                        >
                                            <option value="">Select vehicle manufacturer</option>
                                            {IsGetManuf?.map((MF, index) => (
                                                <option key={index} extraKey={MF?.manufacturername} value={MF?.manufacturerID}>
                                                    {MF.manufacturername}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="floatingSelectManufacturer">Manufacturer</label>
                                        {errors?.PolicyType && <span className="error-text">{errors.PolicyType}</span>}
                                    </div>
                                </li>
                                <li>
                                    <div className="form-floating">
                                        <select
                                            className="form-select"
                                            id="floatingSelectModel"
                                            name="Model"
                                            value={vehicleData.Model || ""}
                                            onChange={VhandleChange}
                                            aria-label="Select vehicle model"
                                        >
                                            <option value="">Select vehicle model</option>
                                            {IsGetModel?.map((Model, index) => (
                                                <option key={index} extraKey={Model?.vehicleName} value={Model.vehicleID}>
                                                    {Model.vehicleName}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="floatingSelectModel">Model</label>
                                        {errors?.PolicyType && <span className="error-text">{errors.PolicyType}</span>}
                                    </div>
                                </li>
                                <li>
                                    <div className="form-floating">
                                        <select
                                            className="form-select"
                                            id="floatingSelectFuel"
                                            name="Fuel"
                                            value={vehicleData.Fuel || ""}
                                            onChange={VhandleChange}
                                            aria-label="Select fuel type"
                                        >
                                            <option value="">Select fuel type</option>
                                            {IsGetFuel?.map((Fuel, index) => (
                                                <option key={index} extraKey={Fuel?.fuelName} value={Fuel.fuelID}>
                                                    {Fuel.fuelName}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="floatingSelectFuel">Fuel</label>
                                        {errors?.PolicyType && <span className="error-text">{errors.PolicyType}</span>}
                                    </div>
                                </li>
                                <li>
                                    <div className="form-floating">
                                        <select
                                            className="form-select"
                                            id="floatingSelectVariant"
                                            name="Varient"
                                            value={vehicleData.Varient || ""}
                                            onChange={VhandleChange}
                                            aria-label="Select vehicle variant"
                                        >
                                            <option value="">Select vehicle variant</option>
                                            {IsGetVarient?.map((Varient, index) => (
                                                <option key={index} extraKey={Varient?.variantName} value={Varient.variantID}>
                                                    {Varient.variantName}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="floatingSelectVariant">Variant</label>
                                        {errors?.PolicyType && <span className="error-text">{errors.PolicyType}</span>}
                                    </div>
                                </li>

                            </ul>
                            {!isEditClicked &&
                                <button className="btn-customr" onClick={onUpdateClick}>
                                    Update
                                </button>
                            }
                        </>
                    }
                    {currentFormType === "init" &&
                        <>
                            <ul>
                                <li>
                                    <div className="form-floating">
                                        <select
                                            className="form-select"
                                            id="floatingSelectPolicyType"
                                            name="PolicyType"
                                            value={formData.PolicyType}
                                            onChange={handleChange}
                                            aria-label="Floating label select new"
                                        >
                                            <option value="">Select policy type</option>
                                            {IsProductList.map((product, index) => (
                                                <option key={index} value={product.ProductCode}>
                                                    {product.ProductName}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="floatingSelectPolicyType">Policy Type</label>
                                        {errors.PolicyType && (
                                            <span className="error-text">{errors.PolicyType}</span>
                                        )}
                                    </div>
                                </li>
                                <li>
                                    <div className="form-floating">
                                        <select
                                            className="form-select"
                                            id="floatingSelectRelation"
                                            name="Relation"
                                            value={formData.Relation}
                                            onChange={handleChange}
                                            aria-label="Floating label select example"
                                        >
                                            <option value="">Who is the policy holder</option>
                                            {GetRelatioship?.map((Relation, index) => (
                                                <option key={index} value={Relation.key}>
                                                    {Relation.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="floatingSelectRelation">Policy Holder</label>
                                        {errors.Relation && (
                                            <span className="error-text">{errors.Relation}</span>
                                        )}
                                    </div>
                                </li>
                                {/*<li>*/}
                                {/*    <div className="form-floating">*/}
                                {/*        <input*/}
                                {/*            type="text"*/}
                                {/*            className="form-control"*/}
                                {/*            id="customerName"*/}
                                {/*            name="CustomerName"*/}
                                {/*            value={(formData.CustomerName = IsCustomer)}*/}
                                {/*            onChange={handleChange}*/}
                                {/*            placeholder="Customer Name"*/}
                                {/*        />*/}
                                {/*        <label htmlFor="customerName">Customer Name</label>*/}
                                {/*        {errors.CustomerName && (*/}
                                {/*            <span className="error-text">{errors.CustomerName}</span>*/}
                                {/*        )}*/}
                                {/*    </div>*/}
                                {/*</li>*/}
                                <li>
                                    <div className="form-floating">
                                        <select
                                            className="form-select"
                                            id="floatingSelectPolicyType"
                                            name="Insurer"
                                            value={formData.Insurer}
                                            onChange={handleChange}
                                            aria-label="Floating label select example"
                                        >
                                            <option value="">Select Insurere</option>
                                            {IsInsurerList.map((insurer, index) => (
                                                <option key={index} value={insurer.CompanyId}>
                                                    {insurer.CompanyName}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="insurer">Insurer</label>
                                        {errors.Insurer && (
                                            <span className="error-text">{errors.Insurer}</span>
                                        )}
                                    </div>
                                </li>
                                {(formData.PolicyType == "" || formData.PolicyType == "CAR" || formData.PolicyType == "TWO" || formData.PolicyType == "TAXI" || formData.PolicyType == "GCV" || formData.PolicyType == "PCV") &&

                                    <>
                                        <li>
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="vehicleNo"
                                                    name="VehicleNo"
                                                    value={formData.VehicleNo}
                                                    onChange={handleChange}
                                                    placeholder="Vehicle Number"
                                                />
                                                <label htmlFor="vehicleNo">Vehicle Number</label>
                                                {errors.VehicleNo && (
                                                    <span className="error-text">{errors.VehicleNo}</span>
                                                )}
                                            </div>
                                        </li>
                                    </>
                                }
                                <li>
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="policyNo"
                                            name="PolicyNo"
                                            value={formData.PolicyNo}
                                            onChange={handleChange}
                                            placeholder="Policy Number"
                                        />
                                        <label htmlFor="policyNo">Policy Number</label>
                                        {errors.PolicyNo && (
                                            <span className="error-text">{errors.PolicyNo}</span>
                                        )}
                                    </div>
                                </li>
                                <li>
                                    <div className="form-floating">
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="policyExpiryDate"
                                            name="PolicyExpiryDate"
                                            value={formData.PolicyExpiryDate}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="policyExpiryDate">Policy Expiry Date</label>
                                        {errors.PolicyExpiryDate && (
                                            <span className="error-text">{errors.PolicyExpiryDate}</span>
                                        )}
                                    </div>
                                </li>
                                {/*<li>*/}
                                {/*    <div className="form-floating">*/}
                                {/*        <input*/}
                                {/*            type="file"*/}
                                {/*            className="form-control"*/}
                                {/*            id="policyPdfData"*/}
                                {/*            name="PolicyPdfData"*/}
                                {/*            onChange={handleFileChange}*/}
                                {/*        />*/}
                                {/*        <label htmlFor="policyPdfData">Policy PDF</label>*/}
                                {/*        {errors.PolicyPdfData && (*/}
                                {/*            <span className="error-text">{errors.PolicyPdfData}</span>*/}
                                {/*        )}*/}
                                {/*    </div>*/}
                                {/*</li>*/}
                            </ul>
                            <button className="btn-customr" onClick={PolicySync}>
                                Submit
                            </button>
                        </>
                    }
                    </div>
                :
                <>{currentFormType === "view" && <SaveData data={SendData} onEditClick={onEditClick} />}</>

                 }
            </div>

        </div>
    );
};

export default PolicySyncingForm;
